import logoTimesNow from '../Images/press-logos/times-now.svg';
import logoMidDay from '../Images/press-logos/mid-day.png';
import logoWion from '../Images/press-logos/wion.svg';
import logoNdtv from '../Images/press-logos/ndtv.svg';
import logoZeeNews from '../Images/press-logos/zee-news.svg';
import logoHindustanTimes from '../Images/press-logos/hindustan-times.svg';
import logoNavbharatTimes from '../Images/press-logos/navbharat-times.gif';

// The outlets Poonam has been featured in (the list published on the About page). `href` only where there is a
// confirmed article link; a missing logo shows the outlet's name as text instead of a wrong or made-up logo.
export const FEATURED_PRESS = [
  { name: 'Hindustan Times', logo: logoHindustanTimes },
  { name: 'Times Now', logo: logoTimesNow },
  { name: 'Mid-Day', logo: logoMidDay },
  { name: 'WION News', logo: logoWion, href: 'https://www.wionews.com/trending/guru-purnima-2026-opens-doors-to-the-spiritual-realm-1785299579734' },
  { name: 'ETV Bharat', href: 'https://www.etvbharat.com/en/lifestyle/restore-the-balance-of-shiva-and-shakti-in-practice-enn26072803506' },
  { name: 'NDTV Lifestyle', logo: logoNdtv },
  { name: 'Zee News', logo: logoZeeNews },
  { name: 'Navbharat Times', logo: logoNavbharatTimes },
  { name: 'Boldsky' },
];

export { logoHindustanTimes };
